import React, { useEffect, useState } from 'react';

import { ErrorMessages } from '../../types/common/Messages';

import { SearchBody } from './SearchBody';
import { CoverProgressLoading } from '../../components/CoverProgressLoading';
import { ErrorModalModal } from '../../components/ErrorModal';
import { searchApi } from '../../api/search';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { reset as setScreenMoveReset } from '../../slice/ScreenHistorySlice';

type SearchProps = {
    setOpenTutorialModal: (value: boolean) => void;
};

// 検索TOP
export const Search: React.FC<SearchProps> = ({ setOpenTutorialModal }) => {
    const dispatch = useAppDispatch();
    // dispatchされたサジェスト用の検索一覧結果を取得
    const products = useAppSelector((s) => s.Conditions);
    // API実行状況管理
    const [loadingStatus, setLoadingStatus] = useState(false);
    // APIエラー発生時のエラーモーダル管理
    const [errorModalMessages, setErrorModalMessages] = useState<Array<string>>([]);
    const [openErrorlModal, setOpenErrorModal] = useState<boolean>(false);

    useEffect(() => {
        const getSuggestList = async () => {
            if ((products?.items ?? []).length === 0) {
                const result = await searchApi.searchList(dispatch);
                if (result === '') {
                    setLoadingStatus(true);
                } else {
                    setErrorModalMessages([ErrorMessages.API300x_SEARCH_ERROR.replace('%1', result)]);
                    setOpenErrorModal(true);
                }
            } else {
                setLoadingStatus(true);
            }
        };
        // サジェスト取得
        void getSuggestList();
        // 遷移履歴を初期化
        dispatch(setScreenMoveReset());
    }, []);

    return (
        <>
            <ErrorModalModal
                errorMessages={errorModalMessages}
                openState={openErrorlModal}
                setOpenState={setOpenErrorModal}
            />
            {loadingStatus ? (
                <SearchBody setOpenTutorialModal={setOpenTutorialModal} searchResult={products} />
            ) : (
                <CoverProgressLoading />
            )}
        </>
    );
};
